import React from 'react';

import HtmlPreviewBox from '@dashboard/components/preview-boxes/HtmlPreviewBox';

import MessageArea from '../components/MessageArea';

import PreviewModal from './PreviewModal';

type Props = {
  loading: boolean;
  errorMessage?: string;
  subject: JsxNode;
  preheader: JsxNode;
  bodyHtml: string | undefined | null;
};
export default function Preview({ loading, subject, preheader, bodyHtml, errorMessage }: Props) {
  return (
    <MessageArea subject={subject} preheader={preheader}>
      <PreviewModal loading={loading} errorMessage={errorMessage ?? null} />
      <HtmlPreviewBox value={bodyHtml} />
    </MessageArea>
  );
}
